import { NgModule } from '@angular/core';
import { EffectsModule } from '@ngrx/effects';
import { StoreModule } from '@ngrx/store';
import { baseLocationWorkingTimeEffects, baseLocationWorkingTimeReducer } from '../../_store';

@NgModule({
  imports: [
    StoreModule.forFeature('locationWorkingTime', baseLocationWorkingTimeReducer.BaseLocationWorkingTimeReducer),
    EffectsModule.forFeature([baseLocationWorkingTimeEffects.BaseLocationWorkingTimeEffects]),
  ],
})
export class BaseLocationWorkingTimeStoreModule {}
